<router-outlet />
<p-toast />
